import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { VardiyaDevirEditComponent } from './vardiya-devir-edit.component';
import { VardiyaDevirKartComponent } from './vardiya-devir-kart.component';
import { VardiyaDevirKartSadeComponent } from './vardiya-devir-kart-sade.component';

@DinamikBilesen({
  id: 'vardiya-devir',
  baslik: 'Vardiya Devir',
  aciklama: 'Vardiya devir teslim',
  ikon: 'sync',
  kategori: 'uretim',
})
class VardiyaDevir {
  paylas_kutusu = VardiyaDevirEditComponent;
  paylasilmis_kart = VardiyaDevirKartComponent;
  paylasilmis_kart_sade = VardiyaDevirKartSadeComponent;
  hesaplamalar = {
    pipeline: [
      { $match: { _uid: '{{kartId}}', silindi: { $ne: true } } },
      { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'icerikDetay' } },
      { $unwind: { path: '$icerikDetay', preserveNullAndEmptyArrays: false } },
      { $group: {
        _id: null,
        toplam: { $sum: 1 },
        toplamUretim: { $sum: { $ifNull: ['$icerikDetay.ek.uretimAdedi', 0] } },
        toplamFire: { $sum: { $ifNull: ['$icerikDetay.ek.fireAdedi', 0] } }
      }}
    ]
  };
}
